module.exports = __webpack_public_path__ + "static/media/ManWithKey.d330fae3.svg";